import React from 'react';

import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const { Title } = Typography;

const PlaceholderPage = ({ titleKey, role = 'admin' }) => {
  const { t } = useTranslation();

  return (
    <div className={`${role}-page`}>
      <Title level={2} className={`${role}-page-title`}>
        {t(titleKey)}
      </Title>
    </div>
  );
};

export default PlaceholderPage;
